import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import { formatFileName } from 'utils/func';
import {
  useMutationCreateRegisterResultAppendix,
  useMutationDeleteRegisterResultAppendix,
} from 'utils/hooks/registerResult';
import { REGISTER_RESULT_FILE_TYPE, TOAST } from 'constant';
import { confirmPopup, ConfirmPopup } from 'primereact/confirmpopup';
import { toast } from 'layout';
import CustomFileUpload from '../UploadFile';

export default function UploadAppendixes({
  disabled,
  appendixeArray,
  handleDownloadFile,
  registerResultId,
  refetch,
  onSubmit,
}) {
  // #region Data
  const { t } = useTranslation();

  const { mutateAsync: uploadAppendix } = useMutationCreateRegisterResultAppendix();
  const { mutateAsync: deleteAppendix } = useMutationDeleteRegisterResultAppendix();

  const handleUploadFile = async (file) => {
    try {
      let idSent = registerResultId;
      if (!idSent) {
        idSent = await onSubmit();
      } else {
        await onSubmit();
      }
      const formData = new FormData();
      formData.append('file', file);
      await uploadAppendix({ registerResultId: idSent, body: formData });
      toast(TOAST.SUCCESS, 'Tải phụ lục thành công');
      refetch();
    } catch (error) {
      toast(TOAST.ERROR, 'Tải phụ lục thất bại');
    }
  };

  const accept = async (index, appendixId) => {
    try {
      await deleteAppendix({ registerResultId, appendixId });
      toast(TOAST.SUCCESS, 'Xoá phụ lục thành công');
      refetch();
    } catch {
      toast(TOAST.ERROR, 'Xoá phụ lục thất bại');
    }
  };

  const confirmDelete = (event, index, appendixId) => {
    confirmPopup({
      target: event.currentTarget,
      message: 'Bạn có chắc muốn xoá phụ lục này không?',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'reject',
      acceptClassName: 'p-button-danger',
      accept: () => accept(index, appendixId),
      acceptLabel: t('formLayout.action.ok'),
      rejectLabel: t('formLayout.action.cancel'),
    });
  };

  // #endregion Data
  return (
    <>
      <h6 className="font-bold">{t('contract.form.appendixies')}</h6>
      <div className="file-appendix-table">
        <table>
          <tbody>
            {appendixeArray?.map((summaryReportAppendixe) => (
              <tr>
                <td>
                  <span
                    key={summaryReportAppendixe?.filename}
                    className="p-button p-button-text p-button-sm mt-1 p-0"
                    onClick={() => {
                      handleDownloadFile(
                        summaryReportAppendixe?.filename,
                        REGISTER_RESULT_FILE_TYPE.APPENDIXES
                      );
                    }}
                  >
                    <i className="pi pi-file-pdf text-red-500 text-xl" />{' '}
                    <span className="text-blue-500 underline font-italic text-base ml-2">
                      {formatFileName(summaryReportAppendixe?.filename)}
                    </span>
                  </span>
                </td>
                {!disabled && (
                  <td>
                    <Button
                      icon="pi pi-times"
                      rounded
                      text
                      severity="danger"
                      aria-label="Cancel"
                      type="button"
                      onClick={(event) => {
                        confirmDelete(
                          event,
                          summaryReportAppendixe?.id,
                          summaryReportAppendixe?.id
                        );
                      }}
                      disabled={disabled}
                    />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="relative">
        {!disabled && (
          <CustomFileUpload
            name="expenditureAndAppendix"
            maxFileSize={30000000}
            acceptOnly="pdfOnly"
            onUpload={handleUploadFile}
          />
        )}
      </div>
      <ConfirmPopup />
    </>
  );
}

UploadAppendixes.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  handleDownloadFile: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
  appendixeArray: PropTypes.array,
  registerResultId: PropTypes.string,
  refetch: PropTypes.func,
  onSubmit: PropTypes.func,
};

UploadAppendixes.defaultProps = {
  disabled: false,
  handleDownloadFile: () => null,
  appendixeArray: [],
  registerResultId: null,
  refetch: () => null,
  onSubmit: () => null,
};
